import React from "react";

import {
  Library,
  CloudUpload,
  Archive,
  BugOff,
  Shrink,
  Bookmark,
  User,
} from "lucide-react";

import style from "./MobileNav.module.scss";

//Components
import NavItem from "../NavItem";

const MobileNav = () => {
  const isAuth = false;

  const onClickgout = () => {};
  return (
    <nav className={style.nav}>
      <div className={style.navContent}>
        <div className={style.navSection}>
          <NavItem to="/lib" title={"lib"} Icon={Library} />
          <NavItem to="/bookmark" title={"bookmark"} Icon={Bookmark} />
          {/* <NavItem to="/upload" title={"upload(!)"} Icon={CloudUpload} /> */}
          <NavItem
            to="/"
            Icon={Shrink}
            width="40px"
            height="40px"
            strokeWidth="0.75px"
          />
          <NavItem to="/forum" title={"forum"} Icon={Archive} />
          {isAuth ? (
            <>
              <NavItem to="/profile" title={"profile"} Icon={User} />
            </>
          ) : (
            <>
              <NavItem to="/login" title={"profile"} Icon={User} />
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default MobileNav;
